import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import { Viewer } from "../../../../../widgets/Viewer";
import { withRouter } from 'react-router-dom';
import { Spinner } from '@blueprintjs/core';

import { loadThankYouNotes, deleteThankYouNote } from '../../../../../../redux/actions/thankYouNote.actions';
 
const ThankYouNoteRow = props => {
    return (    
        <tr onClick={() => props.editRow(props.thankYouNote)}>
            <td>{moment(props.thankYouNote.date_written).format('ddd, MMM Do, YYYY')}</td>
            <td onClick={e => e.stopPropagation()}>
                <Viewer src={props.thankYouNote.image || props.thankYouNote.dropbox_image_share_url || ''} style={{ height: '30px' }} thumbnail />
            </td>
            <td>{props.thankYouNote.message}</td>
            <td className="action-row">
                <div className="pt-button pt-intent-danger pt-icon-trash pt-small" onClick={(event) => props.deleteRow({ thankYouNote: props.thankYouNote, event })}>Delete</div>
            </td>
        </tr>
    );
};

class ThankYouNotes extends Component {
    async componentDidMount() {
        const { clientId, progressId } = this.props.match.params;
        await this.props.loadThankYouNotes({ recipientId: clientId, progressId });
    }
    openThankYouModal = () => {
        window.dispatchEvent(new CustomEvent('open-thank-you-note-modal', { detail: {
            ...this.props.match.params,
            recipientId: this.props.match.params.clientId
        }}));
    }
    editRow = (thankYouNote) => {
        const { clientId, progressId } = this.props.match.params;
        const event = new CustomEvent('open-thank-you-note-modal', {
            detail: {
                ...thankYouNote,
                recipientId: clientId,
                progressId
            }
        });
        window.dispatchEvent(event);
    }
    deleteRow = ({ event, thankYouNote }) => {
        event.preventDefault();
        event.stopPropagation();
        const { clientId, progressId } = this.props.match.params;
        const customEvent = new CustomEvent('open-delete-modal', {
            detail: {
                content: `Are you sure you want to delete this thank you note?`,
                onDelete: () => {
                    this.props.deleteThankYouNote({ recipientId: clientId, progressId, thankYouNoteId: thankYouNote.id });
                }
            }
        });
        window.dispatchEvent(customEvent);
    }
    render() {
        const { thankYouNotes } = this.props;
        return (
            <div className="panel-thank-you-notes panel-content">
                { this.props.allLoading ?
                    <div className="spinner-container">
                        <Spinner large />
                    </div> :
                    thankYouNotes.length ?
                        <table className="general-table pt-html-table pt-interactive">
                            <thead>
                                <tr>
                                    <th>Date Written</th>
                                    <th>Preview</th>
                                    <th>Message</th>
                                </tr>
                            </thead>
                            <tbody>
                                { thankYouNotes.map((thankYouNote, i) => (
                                    <ThankYouNoteRow key={i}
                                        thankYouNote={thankYouNote}
                                        editRow={this.editRow}
                                        deleteRow={this.deleteRow} />
                                ))}
                            </tbody>
                        </table> :
                        <div className="intro">
                            <div className="intro-text">
                                No thank you notes. Start by <span className="link" onClick={this.openThankYouModal} >adding one</span> 
                            </div>
                        </div>
                }
            </div>
        );
    }
}

const mapStateToProps = (state, ownProps) => ({
    thankYouNotes: state.thankYouNote.thankYouNotes,
    thankYouNotesById: state.thankYouNote.thankYouNotesById,
    allLoading: state.thankYouNote.allLoading
});
  
const mapDispatchToProps = {
    loadThankYouNotes,
    deleteThankYouNote
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ThankYouNotes));


// WEBPACK FOOTER //
// ./src/components/main/dashboard/panel/recipient/progress-panels/ThankYouNotes.jsx